export * from './user-name.component';


// WEBPACK FOOTER //
// ./src/app/shared/components/user-name/index.ts